/*
 *   File : filter-card.js
 *   Author : https://evoqins.com
 *   Description : Filter label Component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import { Icon } from '../Icon'

function FilterCard(props) {
    return (
        <div className='d-flex justify-content-between align-items-center gap-1 cursor-pointer py-1 padding-6-lr e-border-radius-50 e-border-1px-bright-silver'
            onClick={props.handleOpenFilterModal}>
            <Icon icon="filter"
                size="1rem" />
            <span className='e-text-neutral-navy e-alt-font-poppins e-font-12 e-font-weight-400 line-height-18px'>
                Filter by:  {props.filterText}
            </span>
            <Icon icon="phone-dropdown-arrow"
                size="1rem" color="#44475B" />
        </div>
    )
}

export default FilterCard